module.exports = __webpack_public_path__ + "img/23.5c70bdcc.png";